module.exports = __webpack_public_path__ + "img/esr_2021_min.22695304.jpg";